import { format } from 'date-fns/esm'
import React, { useState } from 'react'
import intervalToDuration from 'date-fns/intervalToDuration'

function Countdown(props) {
	const [days, setDays] = useState(0)
	const [hours, setHours] = useState(0)
	const [minutes, setMinutes] = useState(0)
	const [seconds, setSeconds] = useState(0)

	const timerInt = setTimeout(() => {
		const result = intervalToDuration({
			start: new Date(),
			// "yyyy-MM-dd'T'HH:mm:ss.SSSxxx"
			end: new Date(2022, 2, 17, 0, 0, 0),
		})
		setDays(result.days)
		setHours(result.hours)
		setMinutes(result.minutes)
		setSeconds(result.seconds)
	}, 1000)
	// console.log(new Date().toUTCString())
	return (
		<>
			<div className="countdown" id="countdown">
				<div className="container-main w-container text-center">
					<h2 className="h3 headline my-2">Presale Starts From</h2>
					<div id="countdown">
						<ul class="countdown-ul">
							<li>
								<span id="days">{days}</span>
								days
							</li>
							<li>
								<span id="hours"> {hours}</span>
								Hours
							</li>
							<li>
								<span id="minutes">{minutes}</span>
								Minutes
							</li>
							<li>
								<span id="seconds"> {seconds} </span>
								Seconds
							</li>
						</ul>
					</div>
					{/* show what to do after timer reaches */}
					<div id="content" className="show"></div>
				</div>
			</div>
		</>
	)
}

export default Countdown
